var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"giveaway-card"},[_c('Avatar',{attrs:{"borderRadius":"square","avatar":_vm.gives.giveaway_image}}),_c('span',{staticClass:"giveaway-card__name"},[_vm._v(" "+_vm._s(_vm.gives.giveaway_name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }